import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';

@Component({
  selector: 'app-payfile-review',
  templateUrl: './payfile-review.component.html',
  styleUrl: './payfile-review.component.css'
})
export class PayfileReviewComponent implements OnInit {

  orders: any[] = [];
  isModalVisible = false;
  selectedOrder: any = null;
  isLoading = false;

  constructor(private dataService: DataserviceService, private message: NzMessageService) {}

  ngOnInit() {
    this.loadCancelledReviews();
  }

  loadCancelledReviews() {
    this.isLoading = true;
    this.dataService.getData('work-order/payfile-review')
      .subscribe((res: any) => {
        if (res.result === 'success') {
          console.log(res)
          this.orders = res.data;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.message.error('Failed to load cancelled reviews');
        }
      })
  }

  showResolveModal(order: any){
    this.selectedOrder = order;
    this.isModalVisible = true;
  }

  handleOk(){
    this.isLoading = true;
    console.log(this.selectedOrder)
    this.dataService.postData(this.selectedOrder.id, 'work-order/payfile-review-update')
      .subscribe((res: any) => {
        console.log(res)
        if (res.result === 'success') {
          this.message.success('Review has been completed');
          this.loadCancelledReviews();
          this.isModalVisible = false;
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.message.error('Failed to complete review');
        }
      },
        (error: any) => {
          this.isLoading = false;
          this.message.error('Failed to complete review');
        })
  }

  handleCancel(){
    this.isModalVisible = false;
    this.selectedOrder = null;
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { sort } = params;
    const currentSort = sort.find((s: any) => s.value !== null);
  
    if (currentSort) {
      const { key, value } = currentSort;
      this.orders = [...this.orders].sort((a, b) => {
        let valA = a[key];
        let valB = b[key];
  
        if (key === 'customer_name') {
          valA = `${a.first_name} ${a.last_name}`;
          valB = `${b.first_name} ${b.last_name}`;
        }
  
        if (key === 'sale_date') {
          valA = new Date(a.sale_date);
          valB = new Date(b.sale_date);
        }
  
        if (typeof valA === 'string' && typeof valB === 'string') {
          return value === 'ascend' ? valA.localeCompare(valB) : valB.localeCompare(valA);
        }
  
        return value === 'ascend' ? valA - valB : valB - valA;
      });
    }
  }

  // submit(){
  //   this.isLoading = true;
  //   this.dataService.postData(this.selectedOrder.id, 'customers/submit-update-eligibility').subscribe((res: any) => {
  //     if (res.result === 'success') {
  //       this.message.success('Review has been completed');
  //       this.loadCancelledReviews();
  //       this.isModalVisible = false;
  //       this.isLoading = false;
  //     } else {
  //       this.isLoading = false;
  //       this.message.error('Failed to complete review');
  //     }
  //   }), (error: any) => {
  //     this.isLoading = false;
  //     this.message.error('Failed to complete review');
  //   }}

}
